class Country {
  constructor({ name, html, gold, silver, bronze, total, position }) {
    this.name = name;
    this.html = html;
    this.gold = gold;
    this.silver = silver;
    this.bronze = bronze;
    this.total = total;
    this.position = position;
  }
}

class Detail {
  constructor({ name, html, isOpen = false }) {
    this.name = name;
    this.html = html;
    this.isOpen = isOpen;
  }

  close() {
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
  }
}


const countryList = [];
const details = {};

/**
 *
 * @param {object} country pais
 * @returns {string}
 */
function createCountryRow(country) {
  return `<li class="medals-table__country" data-row="${country.name}">${country.html}</li>`;
}

/**
 *
 * @param {object} e evento
 */
function rowClick(e) {
  const $target = $(e.currentTarget);
  const attribute = $target.attr('data-row');
  const detail = details[attribute.trim()];

  if (detail.isOpen) {
    $(`[data-row-country-detail="${attribute.trim()}"]`).remove();
    detail.close();
  } else {
    $target.after(detail.html);
    detail.open();
  }
}

/**
 *
 * @param {object} e evento
 */
function columnClick(e) {
  const $target = $(e.currentTarget);
  const criteria = $target.attr('data-column');

  countryList.sort((a, b) => {
    let response;

    if (a[criteria] !== b[criteria]) {
      response = b[criteria] - a[criteria];
    } else if (a.gold !== b.gold) {
      response = b.gold - a.gold;
    } else if (a.silver !== b.silver) {
      response = b.silver - a.silver;
    } else if (a.bronze !== b.bronze) {
      response = b.bronze - a.bronze;
    } else if (a.total !== b.total) {
      response = b.total - a.total;
    } else {
      response = a.position - b.position;
    }
    return response;
  });

  $('[data-table-body]')
    .css({ opacity: 0 })
    .html(countryList.reduce((list, country) => list + createCountryRow(country), ''))
    .animate({ opacity: 1 }, 300);

  $('[data-column]').removeClass('medals-table__cell--selected');
  $target.addClass('medals-table__cell--selected');
  $(`[data-row-${criteria}]`).addClass('medals-table__cell--selected');

  $('[data-row]').click(rowClick);
}

/**
 *
 * @param {object} country pais
 * @returns {Country}
 */
function createCountryObj(country) {
  return new Country({
    name: country.find('[data-row-name]').text(),
    html: country.html(),
    gold: Number(country.find('[data-row-gold]').text()),
    silver: Number(country.find('[data-row-silver]').text()),
    bronze: Number(country.find('[data-row-bronze]').text()),
    total: Number(country.find('[data-row-total]').text()),
    position: Number(country.find('[data-row-position]').text()),
  });
}

export default class Table {
  static init() {
    const $rows = $('[data-row]');
    const $detailsRows = $('[data-row-detail]');

    $rows.map((index, country) => countryList.push(createCountryObj($(country))));

    $detailsRows.each((index, detail) => {
      const $detail = $(detail);
      details[$detail.attr('data-row-detail')] = new Detail({
        name: $detail.attr('data-row-detail'),
        html: $detail.html(),
      });
    });

    $('[data-column]').click(columnClick);
    $('[data-column="gold"]').trigger('click');
  }
}



// WEBPACK FOOTER //
// local_static/templates/quadro_de_medalhas/2018/assets/scripts/partials/sections/medals-table.js